const FEATURE_NAME = 'authentication';

export const authenticationQueryKeyMap = {
  me: () => [FEATURE_NAME, 'me'],
  myNotificationBadges: () => [FEATURE_NAME, 'myNotificationBadges'],
};
